import React, { useEffect } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { Select, InputText } from "../../../../../../components/Habitacional/core/Form"
import Grid from "../../../../../../components/Habitacional/core/Grid"
import { OptionsSelectDataVisit } from "../utils/ConstantsFormDFI"
import * as S from "../FormDFI.Style"
import Button from "../../../../../../components/Habitacional/core/Button"
import { handleScrollSmooth } from "../../../../../../components/Habitacional/CardActivateInsurance/CardActivateInsurance"

const FormStepTwo = ({ isLoading }) => {
    const { control, formState: { errors }, watch, setValue } = useFormContext()

    const ConfirmPhoneNumber = watch("PhoneNumber");
    const ConfirmAddress = watch("Address");

    useEffect(() => {
        setValue("ConfirmPhoneNumber", ConfirmPhoneNumber);
        setValue("ConfirmAddress", ConfirmAddress);
    }, [ConfirmPhoneNumber, ConfirmAddress, setValue]);


    return (
        <S.ContentFormDFI>
            <Grid container spacingColumn={7.5} spacingRow={3}>
                <Grid item md={4} lg={4} xl={4}>
                    <Controller
                        name="SelectDataVisit"
                        control={control}
                        render={({ field }) => (
                            <Select
                                id="SelectDataVisit"
                                name="SelectDataVisit"
                                title="Melhor período"
                                placeholder="Escolha"
                                options={OptionsSelectDataVisit}
                                value={field.value?.value}
                                selected={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                errorMessage={errors?.SelectDataVisit?.message}
                                isRequired
                                {...field}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={4} lg={4} xl={4}>
                    <Controller
                        name="ConfirmPhoneNumber"
                        control={control}
                        render={({ field }) => (
                            <InputText
                                id="ConfirmPhoneNumber"
                                name="ConfirmPhoneNumber"
                                placeholder="(99)9 9999-9999"
                                mask="(99)9 9999-9999"
                                title="Confirme se o telefone está correto"
                                errorMessage={errors?.ConfirmPhoneNumber?.message}
                                hasError={errors?.ConfirmPhoneNumber?.message}
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                isRequired
                            />
                        )}
                    />
                </Grid>
                <Grid item md={4} lg={4} xl={4}>
                    <Controller
                        name="ConfirmAddress"
                        control={control}
                        render={({ field }) => (
                            <InputText
                                id="ConfirmAddress"
                                name="ConfirmAddress"
                                title="Confirme se o endereço está correto"
                                hasError={errors?.ConfirmAddress?.message}
                                errorMessage={errors?.ConfirmAddress?.message}
                                onChange={(e) => field.onChange(e.target.value)}
                                value={field.value}
                                isRequired
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <S.TextError>* Campos obrigatórios</S.TextError>
            <S.ContentButton>
                <Button
                    onClick={() => { handleScrollSmooth() }}
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                >
                    Seguir
                </Button>
            </S.ContentButton>
        </S.ContentFormDFI>
    )
}

export default FormStepTwo